import { catchError, of } from 'rxjs';

import { getApiUrl, API_URL } from '@/utils/api';
import ApiBase from './ApiBase';

export default class CatalogService extends ApiBase {
  static baseUrl = getApiUrl(API_URL.ADMIN, '/contact/catalogue');

  sendCatalog(payload) {
    return this.api.postJSON(CatalogService.baseUrl, payload).pipe(
      catchError(() => of({}))
    );
  }
}
